/**
 * `components.MuiList` — list padding and child `li` radius for menus / selectable lists.
 * Discoverability: `MuiList`, `List`, `ListItem`.
 *
 * @see https://mui.com/material-ui/api/list/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiList(_theme: Theme): Pick<Components<Theme>, 'MuiList'> {
  return {
    MuiList: {
      styleOverrides: {
        padding: {
          padding: 8,
          '& > li': {
            borderRadius: 8,
          },
        },
      },
    },
  };
}
